export const TYPE_EURO = 'e';
export const VALUE_STRING = 5;
